import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        // New flow: backend sends session_token directly
        const sessionToken = params.get('session_token');
        // Legacy fallback: old Emergent session_id exchange
        const sessionId = params.get('session_id');

        if (sessionToken) {
          // Direct token from our own Google OAuth backend
          localStorage.setItem('session_token', sessionToken);
          
          // Fetch user data
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${sessionToken}` }
          });
          const user = response.data;

          console.log('=== GOOGLE OAUTH CALLBACK ===');
          console.log('User:', user.email, '| Admin:', user.is_admin, '| Sub:', user.subscription_status);

          if (user.is_admin === true) {
            navigate('/admin', { replace: true });
            return;
          }
          if (!user.onboarding_completed) {
            navigate('/onboarding', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }

        } else if (sessionId) {
          // Legacy: exchange session_id with backend
          const response = await axios.post(`${API}/auth/session`, null, {
            headers: { 'X-Session-ID': sessionId }
          });
          const { session_token, user } = response.data;
          localStorage.setItem('session_token', session_token);

          if (user.is_admin === true) {
            navigate('/admin', { replace: true });
            return;
          }
          if (!user.onboarding_completed) {
            navigate('/onboarding', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        } else {
          console.error('No session_token or session_id found in callback URL');
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback failed:', error);
        toast.error('Sign in failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-navy-900 border-r-transparent"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
